export enum ProgressMainStage {
  'begin' = 'Begin',
  'form' = 'Form',
  'generator' = 'Generator',
  'summary' = 'Summary',
  'contact' = 'Contact',
  'comparition' = 'Comparition',
  'info' = 'Info',
}
